package org.vreo.devicehub.features.device.presentation.deviceManagement.mainDeviceNavigation

/**
 * Device management state
 */
data class DeviceManagementState(
    val selectedTabIndex: Int = 0
)